import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { history } from "../../../../Layout/Layout";
import { convertStringToElements } from "@vds/html-parsers";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Line } from "@vds/lines";
import { TitleLockup } from "@vds/type-lockups";
import { TextLinkCaret } from "@vds/buttons";
import moment from "moment";
import { media } from "utils/style";
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { replaceHashValues } from "utils/replaceHashValues";
import { handleAEMReactLink } from "utils/handleAEMReactLink";
import { checkNestedObject } from "utils/checkNestedObject";

import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";

class DeleteSuccess extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "breadCrumbs", "landingPage")) {
      const {
        breadCrumbs: { landingPage, deleteConfirmation }
      } = this.props.pageContent;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/your-data" },
        {
          label: deleteConfirmation,
          path: "/privacy/secure/delete-request-success"
        }
      ]);
    }

    handleAEMReactLink();
    if (checkNestedObject(this.props.pageContent, "delete_confirmation", "sc_pagetitle")) {
      this.props.setA11yContent(
        "Delete request success",
        this.props.pageContent.delete_confirmation.sc_pagetitle
      );
    }
  }

  renderLinks = item => {
    const { uniqueId } = item;
    const { isDataPresentFIOS, isVideoPresentFIOS } = window.reactGlobals;

    const linkDiv = (
      <ButtonContainer key={uniqueId}>
        <TextLinkCaret 
           surface="light"
           style={{ fontFamily:'Verizon-NHG-eDS, Helvetica, Arial, sans-serif', outline:'none', fontSize:'18px', marginBottom: '10px'}} 
           disabled={false} 
           iconPosition="right"
           onClick={() => window.location.href=item.link}
        >
          {item.text}
        </TextLinkCaret>
        <p>{item.desc}</p>
      </ButtonContainer>
    );
    if (window.reactGlobals.amLob.toLowerCase() === "vzt") {
      if (
        (uniqueId === "advertising_information" && isDataPresentFIOS === "N") ||
        (uniqueId === "tv_advertising_information" && isVideoPresentFIOS === "N")
      ) {
        return null;
      }
      return linkDiv;
    }

    if (window.reactGlobals.role.toLowerCase() === "mobilesecure") {
      if (uniqueId === "communication_preferences") {
        return null;
      }
      if (uniqueId === "mobileSecure") {
        return (
          <ButtonContainer key={uniqueId}>
            <AccountMemberLink>{item.text}</AccountMemberLink>
            <p>{item.desc}</p>
          </ButtonContainer>
        );
      }
      if (uniqueId === "advertising_information") {
        return (
          <ButtonContainer key={uniqueId}>
            <TextLinkCaret
              surface="light"
              style={{fontFamily: 'Verizon-NHG-eDS, Helvetica, Arial, sans-serif', outline:'none', fontSize:'18px', marginBottom: '10px'}} 
              disabled={false} 
              iconPosition="right"
              onClick={() => history.push("/privacy/secure/delete-member")}
            >
              {item.text}
            </TextLinkCaret>
            <p>{item.desc}</p>
          </ButtonContainer>
        );
      }
    }

    if (item.role[window.reactGlobals.customRole] === "true") {
      return linkDiv;
    }
    return null;
  };

  renderHeaderContent = () => {
    const pageContentDefault = this.props.pageContent.delete_confirmation;
    const pageContentReturn = this.props.pageContent.delete_returnconfirmation;

    const { hasDeleted, deleteRequestType } = this.props;
    const { amLob, isSingleLineAcct } = window.reactGlobals;

    if (
      (hasDeleted === "Y" && amLob.toLowerCase() !== "vzw") ||
      (hasDeleted === "Y" && isSingleLineAcct) ||
      (hasDeleted === "Y" && deleteRequestType === "all")
    ) {
      return (
        <Fragment>
          <TitleLockup 
            surface='light'
            textAlignment='left'
            data={{
              title:{
                size: 'titleXLarge',
                bold: false,
                children:
                replaceHashValues(pageContentReturn.section_title, {
                  deleteDateOfRequest: moment(cleanDateFormat(this.props.deleteDateOfRequest)).format(
                    "MMM. D, YYYY"
                  )
                })
              },
              subtitle:{
                size: 'bodyLarge',
                children: convertStringToElements(pageContentReturn.section_description)
              }
          }}  
          />
          
        </Fragment>
      );
    }
    return (
      <Fragment>
        <TitleLockup 
            surface='light'
            textAlignment='left'
            data={{
              title:{
                size: 'titleXLarge',
                children: <Header>
                  {pageContentDefault.section_title}
                </Header>
              },
              subtitle:{
                size: 'bodyLarge',
                children: <Div>{convertStringToElements(pageContentDefault.section_description)}</Div>
              }
          }}  
          />
        
      </Fragment>
    );
  };

  render() {
    const pageContent = this.props.pageContent.delete_confirmation;

    if (pageContent === undefined) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    return (
      <Container noTabletPadding>
        <div style={{ maxWidth: "596px" }}>{this.renderHeaderContent()}</div>
        <Line style={{marginTop:"1.5rem"}} type="secondary"/>

        {pageContent.links.map(item => this.renderLinks(item))}
        <Button
          style={{ marginTop: "40px" }}
          onClick={() => this.props.history.push("/privacy/secure/your-data")}
          role="link"
          background={pageContent.buttons[0].type}
        >
          {pageContent.buttons[0].text}
        </Button>
      </Container>
    );
  }
}

const mapStateToProps = ({
  modalState: { showModal },
  pageContent,
  downloadAndDelete: { hasDeleted, deleteDateOfRequest, deleteRequestType }
}) => ({
  showModal,
  pageContent,
  hasDeleted,
  deleteDateOfRequest,
  deleteRequestType
});

export default connect(
  mapStateToProps,
  { handleModalState, setA11yContent, setBreadcrumbList }
)(DeleteSuccess);

DeleteSuccess.propTypes = {
  showModal: PropTypes.bool,
  handleModalState: PropTypes.func,
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object.isRequired
};

const Div = styled.div`

font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.5px;
  h2 {
    font-size: 20px;
    line-height: 19px;
    margin-top: 40px;
  }
`;

const ButtonContainer = styled.div`
  margin: 24px 0;

  p {
    max-width: 596px;
  }
`;



const AccountMemberLink = styled.p`
  font-size: 18px;
  margin-bottom: 10px;
  line-height: 19px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: 0;
    padding: 32px 16px ;
  `}
`;
const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;
  margin-bottom:32px;
${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;